import * as React from 'react';
import { RawDatePicker } from '../../../../components_v2/toolbarFilter/time/DatePicker';
import { setLocalStorage } from '../../../../helpers/localStorage';
import { Translate } from '../../../../styles/global/translate';
import { CheckBoxWorkdayList, SimpleTimePicker } from '../createEventFromLasso';
import { ConstraintType, ModalCalendarH4, ModalCalendarP, ModalCalendarSettingsDescriptionAndDropdown } from '../ModalCalendar';
import { ConstraintProps } from './constraints';

const key = 'WorkingDays';
type Key = typeof key;

export default function WorkingDaysConstraint(props: ConstraintProps) {
	const [constraints, setConstraints] = props.constraintsHook;

	const settings = constraints.get(key) as ConstraintType[Key]['settings'];
	const defaultConstraint = props.defaultConstraints[key];

	return <>
		<ModalCalendarH4>{defaultConstraint.label}</ModalCalendarH4>
		<ModalCalendarSettingsDescriptionAndDropdown>
			<ModalCalendarP>{defaultConstraint.label}</ModalCalendarP>
			<CheckBoxWorkdayList selectedDays={settings.workdays} setSelectedDays={(workdays) => setConstraints(c => {
				setLocalStorage(key + '_workdays', workdays);
				c.set('WorkingDays', { ...settings, workdays });
				return new Map(c);
			})} />
		</ModalCalendarSettingsDescriptionAndDropdown>
		<ModalCalendarSettingsDescriptionAndDropdown style={{ paddingLeft: 1 }}>
			<RawDatePicker
				future
				fillWidth
				height='35px'
				oneDay
				onDatesChange={res => setConstraints(c => {
					const endDate = res.startDate && res.endDate?.isBefore(res.startDate) ? res.startDate.clone() : res.endDate;
					c.set('WorkingDays', { ...settings, ...res, endDate });
					return new Map(c);
				})}
				start={settings?.startDate ?? null}
				end={settings?.endDate ?? null}
				numberOfMonths={1}
			/>
		</ModalCalendarSettingsDescriptionAndDropdown>
		<ModalCalendarSettingsDescriptionAndDropdown>
			<ModalCalendarP><Translate id='map.modal_right.first_event' /></ModalCalendarP>
			<SimpleTimePicker
				currDate={settings.firstEvent}
				onChange={(firstEvent) => {
					setConstraints(c => {
						c.set('WorkingDays', { ...settings, firstEvent });
						return new Map(c);
					});
				}}
			/>
		</ModalCalendarSettingsDescriptionAndDropdown>
		<ModalCalendarP><Translate id='worked_days' />: {getWorkingDaysAmount(settings)}</ModalCalendarP>
	</>;
}

export function getWorkingDaysAmount(constraint: ConstraintType['WorkingDays']['settings'] | undefined) {
	if (constraint) {
		let amount = 0;
		const date = constraint.startDate?.clone().startOf('day');
		const end = constraint.endDate?.clone().endOf('day');
		if (!date || !end) return 0;
		while (date.isBefore(end)) {
			let day = date.day() - 1;
			if (day === -1) day = 6;
			if (constraint.workdays.includes(day)) {
				amount++;
			}
			date.add(1, 'days');
		}
		return amount;
	}
	return 5;
}
